module.exports = __webpack_public_path__ + "img/group-6.2e47f6da.svg";